import React from 'react'
import PriceListLayout from '../../components/layouts/priceListLayout'

export default class CryptoCurrencyRate extends React.Component {
    render(){
        return(
            <PriceListLayout>
                <h1 style = {{ color : 'red' }}>Crypto Currency rate is here</h1>
            </PriceListLayout>
        )
    }
}